import { ricsAndCompanyBranchLabels } from '../constants/branch-labels';
import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const competitorsDefinition: FilterDefinition<TreeFilter> = {
  id: FilterId.COMPETITORS,
  name: 'Competitors',
  selectionListIds: ['rics_k10', 'rics_k400', 'company'],
  selections: [],
  branches: ricsAndCompanyBranchLabels,
  type: FilterType.TREE,
  isVisible: true,
};

export const competitorsHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<TreeFilter>) {
    return definition.selectionListIds;
  },
};
